import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils/cn";

type Tone = "white" | "hay" | "green" | "purple" | "cloud";

const TONE: Record<Tone, string> = {
  white: "bg-white border border-line text-navy",
  hay: "bg-hay border border-hay-bd text-navy",
  green: "bg-green text-white",
  purple: "bg-purple text-white",
  cloud: "bg-cloud border border-line text-navy",
};

export function Card({
  tone = "white",
  className,
  ...p
}: HTMLAttributes<HTMLDivElement> & { tone?: Tone }) {
  return (
    <div
      className={cn(
        "rounded-[18px] shadow-[0_1px_0_rgba(0,0,0,0.02)]",
        TONE[tone],
        className,
      )}
      {...p}
    />
  );
}

export function CardHeader({ className, ...p }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("px-4 pt-4 pb-2", className)} {...p} />;
}

export function CardTitle({ className, ...p }: HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h3
      className={cn("font-display text-base font-bold tracking-tight", className)}
      {...p}
    />
  );
}

export function CardBody({ className, ...p }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("px-4 pb-4", className)} {...p} />;
}
